import { render, staticRenderFns } from "./ParadaTardeCole.vue?vue&type=template&id=7d2d1056&"
import script from "./ParadaTardeCole.vue?vue&type=script&lang=js&"
export * from "./ParadaTardeCole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports